import { render, staticRenderFns } from "./KennenlernenPage.vue?vue&type=template&id=7fc19f20&"
import script from "./KennenlernenPage.vue?vue&type=script&lang=js&"
export * from "./KennenlernenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports